export default {
  name: 'VerifiedByPeople',
}
